// React & Vendor Libs
const { useMemo } = wp.element;

// NekoUI
import { NekoTable, NekoPaging, NekoCheckbox } from '@neko-ui';
import { useTableEntryModal, tableLimit } from './hooks';

import { LoadEntryModal } from '../styled/NekoModal.styled';

const TableEntryModal = ({ ...props }) => {

  const {table, tableEntries, tableColumns, filteredTableColumns, tableColumnsFilter,
    tableCount, tablePage, open, onCloseTableModal, updateTablePage, updateTableColumnsFilter
  } = useTableEntryModal({ ...props });

  const content = useMemo(() => {
    return (
      <>
        {/* <p style={{ marginBottom: 15 }}>You will find those results with all their fields in the console.</p> */}
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px', flexWrap: 'wrap' }}>
          {tableColumnsFilter.map((v) => <div style={{ marginRight: '8px' }}><NekoCheckbox id={v.accessor} label={v.label} checked={v.checked} onChange={(checked) => {
            const i = tableColumnsFilter.findIndex(t => t.accessor === v.accessor);
            const newTableColumnsFilter = [...tableColumnsFilter];
            newTableColumnsFilter[i] = { ...v, checked };
            updateTableColumnsFilter(tableColumns, newTableColumnsFilter);
          }} /></div>)}
        </div>
        <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          <div style={{ marginRight: 10 }}>
          {tableEntries.length > 0 ? <NekoTable columns={filteredTableColumns} selectedItems={[]}
            data={tableEntries.map(v => {
              const list = Object.keys(v).map(o => {
                let content = v[o];
                // if content is longer than 100 chars, show only first 100 chars
                if (typeof content === 'string' && content.length > 100) {
                  content = <>{content.substring(0, 100) + '...'} <br /><small><a href="#" onClick={() => { console.log("Content", v[o]); }}>
                    Write to Browser Console
                  </a></small></>
                }
                return {
                  [o]: <p>{content}</p>
                }
              })
              return list.reduce((obj, item) => Object.assign(obj, item), {});
            })} />: <p>No data.</p>}
          </div>
        </div>
      </>
    );
  }, [filteredTableColumns, tableColumnsFilter, tableEntries]);

  return (
    <LoadEntryModal
        isOpen={open}
        onRequestClose={onCloseTableModal}
        title={`Table: ${table}`}
        contentWidth='100%'
        content={content}
        onOkClick={onCloseTableModal}
        ok='Close'
        okOnEnter={true}
        customButtons={
          <div style={{ marginRight: 'auto' }}>
            <NekoPaging currentPage={tablePage} limit={tableLimit} total={tableCount} onClick={(page) => updateTablePage(page)} />
          </div>
        }
        customButtonsPosition="left"
      />
  );
};

export default TableEntryModal;